import { JugglingScreen } from "@motleyhand/design"
import { createFileRoute } from "@tanstack/react-router"

export const Route = createFileRoute("/(user)/(tenantBc)/prompts/$id")({
  component: RouteComponent,
})

function RouteComponent() {
  return <JugglingScreen />
}
